import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import * as lodash from 'lodash';

let canSearch = true;

//批量下载
export function batchDownload({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.download({ method: 'post', url: '/Business/Document/BatchDownload', data: { DocumentIdList: sectionComponent.child.current?.state.selectedRowKeys }, filename: pageComponent.state.jobData.JobNum + ' Documents.zip', save: true });
    clearSelectedRowKeys(sectionComponent);
  } else {
    message.warning('You must choose at least one document.');
  }
}

//清除选择的key
function clearSelectedRowKeys(sectionComponent) {
  sectionComponent.child.current?.setState({ selectedRowKeys: [] });
  sectionComponent.child.current?.child.map((folder, i) => {
    folder.current?.setState({ selectedRowKeys: [] });
  })
}

//Document列表刷新
export function refreshDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.getSectionDataByDefault();

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = true;
    sectionComponent.setState(sectionComponent.state.section);
  }, 100);

  setTimeout(() => {
    let uie = sectionComponent.state.section.componentList[0].topButtonList[0].buttonList.filter(c => c.actionType === 'Refresh')[0];
    uie.flip = false;
    sectionComponent.setState(sectionComponent.state.section);
  }, 1100);
}

//下载
export function downloadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ url: '/Business/Document/Download/' + parameter.key, data: null, filename: parameter.Name, save: true });
}

//TrackingPage 下载
export function publicDownloadDocument({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ url: '/Business/Document/PublicDownload/' + parameter.key + '?accessCode=' + pageComponent.props.accessCode, data: null, filename: parameter.Name, save: true });
}

//TrackingPage 批量下载
export function publicBatchDownload({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  if (sectionComponent.child.current?.state.selectedRowKeys.length !== 0) {
    globalFunction.download({ method: 'post', url: '/Business/Document/PublicBatchDownload', data: { DocumentIdList: sectionComponent.child.current?.state.selectedRowKeys }, filename: pageComponent.state.jobData.JobNum + ' Documents.zip', save: true });
    clearSelectedRowKeys(sectionComponent);
  } else {
    message.warning('You must choose at least one document.');
  }
}
